// extracted by mini-css-extract-plugin
module.exports = {"root":"TemplatePreviewModal_root__10uwx","info":"TemplatePreviewModal_info__Kbiae"};